import { type ReactNode, useRef, useState } from "react";
import IconButton from "@/shared/components/generic/button/IconButton.tsx";
import IconSliders from "@/shared/components/generic/icons/IconSliders.tsx";
import type { Size } from "@/shared/components/generic/UiEnums.ts";
import { Level } from "@/shared/components/generic/UiEnums.ts";
import PopMenu from "@/shared/components/generic/pop-menu/PopMenu.tsx";
import DisplayOptionsMenu from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/DisplayOptionsMenu.tsx";
import BasicTooltipWithOffset from "@/pages/human-resources/time-management/components/BasicTooltipWithOffset.tsx";
import { useTranslation } from "react-i18next";

interface Properties {
  size: Size;
}

export default function DisplayOptionsButton(props: Properties): ReactNode {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });
  const [popMenuOpen, setPopMenuOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  function toggleMenu(): void {
    setPopMenuOpen((open) => !open);
  }

  function closeMenu(): void {
    setPopMenuOpen(false);
  }

  return (
    <div ref={anchorRef}>
      <BasicTooltipWithOffset title={t("scheduleDisplayOptions.title")}>
        <IconButton
          icon={IconSliders}
          level={Level.TERTIARY}
          size={props.size}
          onClick={toggleMenu}
        />
      </BasicTooltipWithOffset>
      <PopMenu
        open={popMenuOpen}
        anchorEl={anchorRef.current}
        onClose={closeMenu}
        placement={"bottom-start"}
      >
        <DisplayOptionsMenu />
      </PopMenu>
    </div>
  );
}
